import * as R from '@/Router/routes';

export const getDashboardRedirectionUrl = (hasOpenLoan?: boolean) =>
  hasOpenLoan ? R.ACTIVE_LOAN : R.REPEATED_LOAN;
